import { omit } from "@msys/common";
import React from "react";
import { OutgoingQuotesFilters } from "../../main-routes/documents/Quotes.js";
import { CrmCompanyFilterChip } from "../crm-companies/CrmCompanyFilterChip.js";
import { QuotesAcceptanceFilterChips } from "./filters/QuotesAcceptance.js";
import { QuotesBindingFilterChips } from "./filters/QuotesBinding.js";
import { QuotesPublishingFilterChips } from "./filters/QuotesPublishing.js";

export function getDocumentFilterChipsFactory() {
  return function getDocumentFilterChips<F extends OutgoingQuotesFilters>({
    filters,
    setFilters,
  }: {
    filters: F;
    setFilters?: React.Dispatch<React.SetStateAction<F>>;
  }): Array<JSX.Element> {
    const chips: Array<JSX.Element> = [];

    if (filters.filterByDocActors && filters.filterByDocActors?.length) {
      chips.push(
        ...filters.filterByDocActors.map(actorFilter => (
          <CrmCompanyFilterChip
            key={`${actorFilter.type}-${actorFilter.crmOrganisationId}`}
            label={actorFilter.type}
            value={actorFilter.crmOrganisationId}
            onDelete={
              setFilters
                ? () =>
                    setFilters(currentFilters => {
                      const next = currentFilters.filterByDocActors?.filter(
                        filter =>
                          !(
                            filter.crmOrganisationId ===
                              actorFilter.crmOrganisationId &&
                            filter.type === actorFilter.type
                          )
                      );

                      return next && next.length > 0
                        ? {
                            ...currentFilters,
                            filterByDocActors: next,
                          }
                        : (omit(currentFilters, "filterByDocActors") as F);
                    })
                : undefined
            }
          />
        ))
      );
    }

    if (filters.filterAgreement) {
      chips.push(
        <QuotesAcceptanceFilterChips
          key="agreement"
          values={filters.filterAgreement}
          setValues={
            setFilters
              ? value =>
                  value && value.length > 0
                    ? setFilters(filters => ({
                        ...filters,
                        filterAgreement: value,
                      }))
                    : setFilters(
                        filters => omit(filters, "filterAgreement") as F
                      )
              : undefined
          }
        />
      );
    }

    if (filters.filterIsPublished) {
      chips.push(
        <QuotesPublishingFilterChips
          key="publishing"
          values={filters.filterIsPublished}
          setValues={
            setFilters
              ? value =>
                  value && value.length > 0
                    ? setFilters(filters => ({
                        ...filters,
                        filterIsPublished: value,
                      }))
                    : setFilters(
                        filters => omit(filters, "filterIsPublished") as F
                      )
              : undefined
          }
        />
      );
    }

    if (filters.filterIsBinding) {
      chips.push(
        <QuotesBindingFilterChips
          key="binding"
          values={filters.filterIsBinding}
          setValues={
            setFilters
              ? value =>
                  value && value.length > 0
                    ? setFilters(filters => ({
                        ...filters,
                        filterIsBinding: value,
                      }))
                    : setFilters(
                        filters => omit(filters, "filterIsBinding") as F
                      )
              : undefined
          }
        />
      );
    }

    return chips;
  };
}
